import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {t} from '@lingui/core/macro';

import ErrorPage from './ErrorPage';

import styles from './ErrorPage.module.scss';

const NoAuthPage = () => (
    <ErrorPage
        code={403}
        className={styles.forbidden}
        description={(
            <>
                {t`Ошибка`} 403.<br/> {t`Доступ запрещён`}.<br className={styles.alwaysVisible}/>
                {t`У вас нет прав для просмотра этой страницы`}.
            </>
        )}
        linkTo={AppUrls.LOGIN}
        linkLabel={t`Войти в систему`}
    />
);

export default NoAuthPage;
